import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Globals } from '../models/globals.model';
import { ModalComponent } from '../tagmaster/tagmaster.component';
import { HttpService } from './../services/http.service';
import { TagMasterService } from './../services/tagmaster-service';
import { GlobalService } from '../services/global.service';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterFieldTypes } from '../shared/common-constants';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-pi-point',
  templateUrl: './pi-point.component.html',
  styleUrls: ['./pi-point.component.css']
})
export class PiPointComponent implements OnInit {
  public destroyed = new Subject<any>();
  piPointList: MatTableDataSource<any>;
  noData;
  data = {
    "tagId": "",
    "tagDesc": "",
    "engUnits": "",
    "locationName": "",
    "locIdFromPP": "",
    "action": "Create"
  };
  firstTableClass: string = "hideData";
  isLoader: boolean = false;
  displayedColumns = ['tag', 'locationName', 'descriptor', 'engUnits', 'pointSource', 'pointType', 'pointTypeX', 'Action'];

  @ViewChild(MatPaginator) piPointPaginator: MatPaginator;
  @ViewChild(MatSort) piPointTableSort: MatSort;
  tagFilter = new UntypedFormControl('');
  locationFilter = new UntypedFormControl('');
  engUnitsFilter = new UntypedFormControl('');
  pointSourceFilter = new UntypedFormControl('');
  configuredFilter = new UntypedFormControl('');
  pageSize = 50;
  pageIndex = 0;
  sortColumn = 'tag';
  sortDirection = 'asc';
  filterValues = {
    tag: '',
    locationName: '',
    engUnits: '',
    pointSource: '',
    configured: ''
  };

  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;

  constructor(
    public globals: Globals,
    public globalService: GlobalService,
    public httpService: HttpService,
    public tagMasterService: TagMasterService,
    public dialog: MatDialog,
    public router: Router,
    public _router: ActivatedRoute) {
      const emptyList: any[] = [];
      this.piPointList = new MatTableDataSource(emptyList);
  }

  ngOnInit() {
    this.getPiPointList();    

    this.locationFilter.valueChanges
      .subscribe(
        locationName => {
          this.filterValues.locationName = locationName;
          this.piPointList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.tagFilter.valueChanges
      .subscribe(
        tag => {
          this.filterValues.tag = tag;
          this.piPointList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.engUnitsFilter.valueChanges
      .subscribe(
        engUnits => {
          this.filterValues.engUnits = engUnits;
          this.piPointList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.pointSourceFilter.valueChanges
      .subscribe(
        pointSource => {
          this.filterValues.pointSource = pointSource;
          this.piPointList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.configuredFilter.valueChanges
      .subscribe(
        configured => {
          this.filterValues.configured = configured;
          this.piPointList.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  public getPiPointList() {
    this.isLoader = true;  
    this.tagMasterService.getPiPoint((this.pageIndex + 1), this.pageSize, this.sortColumn, this.sortDirection)
      .subscribe((response: any): void => {
        this.isLoader = false;
        this.masterData = [...response.lstPiPoint];
        this.piPointList = new MatTableDataSource(response.lstPiPoint);
        this.noData = this.piPointList.connect().pipe(map(data => data.length === 0));
        this.piPointPaginator.length = response.totalCount;
        this.firstTableClass = "showData";
        this.filterList = [];
        this.createFilterList();
      }, error => {
        console.log('error', error);
      });
    /*NOSONAR
    //this.piPointTableSort.sortChange.subscribe(() => {
    //  debugger;
    //  //this.piPointList.sort = this.piPointTableSort;
    //  this.onSortChange();
    //});
    */
  }

  onSortChange() {
    this.sortColumn = this.piPointTableSort.active;
    if (this.piPointTableSort.direction == 'asc') {
      this.sortDirection = 'desc';
    }
    else {
      this.sortDirection = 'asc';
    }
    this.getPiPointList();
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getPiPointList();
  }

  configureTag(rowData): void {
    Object.keys(this.data).forEach(k => delete this.data[k]);
    this.processConfig(rowData);
   
    this.dialog.open(ModalComponent, {
      width: '80%',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: this.data
    }).afterClosed().subscribe(result => {
     
      if (result.value) {
        this.getPiPointList();
      }
    });
  }

  processConfig(rowData) {
    this.data.tagId = rowData.tag;
    this.data.tagDesc = rowData.descriptor;
    this.data.engUnits = rowData.engUnits;
    this.data.locationName = rowData.locationName;
    this.data.locIdFromPP = rowData.locationId;
    this.isLoader = false;
  }

  /**Creates data for filter list */
  createFilterList() {
    for (let a = 0; a < this.displayedColumns.length - 1; a++) {
      let tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldName = this.globalService.replaceDisplayText(this.displayedColumns[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      if (this.displayedColumns[a] == "tag") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.tag)));
      } else if (this.displayedColumns[a] == "locationName") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.locationName)));
      } else if (this.displayedColumns[a] == "descriptor") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.descriptor)));
      } else if (this.displayedColumns[a] == "engUnits") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.engUnits)));
      } else if (this.displayedColumns[a] == "pointSource") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.pointSource)));
      } else if (this.displayedColumns[a] == "pointType") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.pointType)));
      } else if (this.displayedColumns[a] == "pointTypeX") {
        unique = Array.from(new Set(this.piPointList.data.map(a => a.pointTypeX)));
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.piPointList.data = this.globalService.conditionalDataFiltering(filterResponse, this.piPointList.data);
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    console.dir(index)
    if (index >= 0) {
      console.dir("loaded ")
      this.selectedFilters.splice(index, 1);
      this.piPointList.data = this.masterData.slice(0);
      console.dir(this.masterData.data)
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.piPointList.data = this.globalService.conditionalDataFiltering(element, this.piPointList.data);
        }
      }
    }
  }
}
